import type { AlertData } from "@/hooks/useAlerts";

export function getAlertAction(alert: AlertData): { path: string; label: string } | null {
  if (!alert.reference_id) return null;
  switch (alert.alert_type) {
    case "late_return":
      return { path: `/bookings/${alert.reference_id}/return`, label: "Start Return" };
    case "return_today":
      return { path: `/bookings?highlight=${alert.reference_id}`, label: "View Booking" };
    case "pickup_ready":
      return { path: `/bookings/${alert.reference_id}/pickup`, label: "Start Pickup" };
    case "insurance_expiry":
    case "maintenance_due":
    case "vehicle_idle":
    case "damage_flagged":
      return { path: `/fleet/${alert.reference_id}`, label: "View Vehicle" };
    case "task_escalation":
      return { path: `/maintenance`, label: "View Task" };
    default:
      return null;
  }
}
